// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","navMenu":"Header_navMenu__AWtZ0","toggles":"Header_toggles__l5FC+"};